import { zetApi } from '@zet/network'
import { getQuarterLabel } from '@zet/utils/stringConversion'
import _ from 'lodash'

import {
  IEarningDashboard,
  IFilterDto,
  IMyEarnings,
  INetworkEarnings,
  ITdsReports,
  TdsReport,
} from './types'

const getFilterDto = (filterDto: IFilterDto) => {
  return encodeURIComponent(JSON.stringify(filterDto))
}

export async function getTotalEarning() {
  const { data } = await zetApi.get<IEarningDashboard>('user/totalEarnings/v2')
  return data?.data
}

export async function getMyEarnings() {
  const { data } = await zetApi.get<IMyEarnings>(
    'user/partnerWiseSalesByUser/v2'
  )
  return data?.data
}

export async function getNetworkEarnings() {
  const { data } = await zetApi.get<INetworkEarnings>('user/networkByStatus/v2')
  return data?.data
}

export const getEarningsSummaryByPartner = async (partnerId: number) => {
  const { data } = await zetApi.get(
    `user/earningsByPartner/v2?type=2&partnerId=${partnerId}&filterDto=${getFilterDto(
      {
        filters: [
          {
            key: 'status',
            alias: 't',
            value: null,
          },
        ],
        pagination: {
          offset: 0,
          limit: 10000,
        },
        sort: {
          order: 'descend',
          key: 'retention_period_till',
        },
      }
    )}`
  )
  return { nextOffset: 1, ...data?.data }
}

export const getEarningsByPartner = async (
  offset = 0,
  selectedStatus: Array<string>,
  partnerId: number
) => {
  const { data } = await zetApi.get(
    `user/earningsByPartner/v2?type=1&partnerId=${partnerId}&filterDto=${getFilterDto(
      {
        filters: [
          {
            key: 'status',
            alias: 't',
            value: selectedStatus.length > 0 ? selectedStatus : null,
          },
        ],
        pagination: {
          offset: offset,
          limit: 10,
        },
        sort: {
          order: 'descend',
          key: 'retention_period_till',
        },
      }
    )}`
  )
  return { nextOffset: offset + 1, ...data?.data }
}

export const getEarningsByNetworkChild = async (
  offset = 0,
  selectedStatus: Array<string>,
  childId: number
) => {
  const { data } = await zetApi.get(
    `user/childTransactions/v2?childId=${childId}&filterDto=${getFilterDto({
      filters: [
        {
          key: 'status',
          alias: 't',
          value: selectedStatus.length > 0 ? selectedStatus : null,
        },
      ],
      pagination: {
        offset: offset * 10,
        limit: 10,
      },
      sort: {
        order: 'descend',
        key: 'retention_period_till',
      },
    })}`
  )
  return { nextOffset: offset + 1, ...data?.data }
}

export const getEarningsHistory = async (
  offset = 0,
  selectedStatus: Array<string>
) => {
  const { data } = await zetApi.get(
    `user/earnings/v2?filterDto=${getFilterDto({
      filters: [
        {
          key: 'status',
          alias: 't',
          value: selectedStatus.length > 0 ? selectedStatus : null,
        },
      ],
      pagination: {
        offset: offset * 10,
        limit: 10,
      },
      sort: {
        order: 'descend',
        key: 'retention_period_till',
      },
    })}`
  )
  return { nextOffset: offset + 1, ...data?.data }
}

export async function getTdsReports(year: string) {
  const { data } = await zetApi.get<ITdsReports>(
    `api/report/tds/v2?year=${year}`
  )
  if (data?.data) {
    return {
      ...data?.data,
      reports: _.map(data?.data?.reports, (r: TdsReport) => {
        return {
          ...r,
          label: getQuarterLabel(r?.quarter, year),
        }
      }),
    }
  }
  return data?.data
}
